export const proj = [
  {
    title: "Paisaflix",
    description: " Challenge de Paisanos, utilizando React y Next.js",
    img: "paisaflix.png",
    url: "https://paisaflix-sebastiananea.vercel.app/",
    github: "https://github.com/sebastiananea/paisaflix",
  },
  {
    title: "Rocket App",
    description:
      " Proyecto grupal, pensado para instituciones que necesitan lograr trabajo en equipo integrando a sus alumnos. Incluye chats, mesas con asignacion aleatoria y servicio de videollamada externo",
    img: "rocket.png",
    url: "https://rocketprojectarg.netlify.app/",
    github: "https://github.com/sebastiananea/RocketFrontend",
  },
  {
    title: "Agencia de Viajes",
    description:
      "Proyecto utilizando Node JS, con PUG como motor de plantillas y MySql como BBDD",
    img: "agencia.png",
    url: "https://agenciaviajesnodesa.herokuapp.com/",
    github: "https://github.com/sebastiananea/agenciaViajesNodeJS",
  },
  {
    title: "Estilo Acordeon",
    description: "Pequeña practica en React con useState",
    img: "Acordion.png",
    url: "https://accordionreactsebaanea.netlify.app/",
    github: "https://github.com/sebastiananea/Accordion-Reactjs",
  },
  {
    title: "Menu",
    description: "Practica de menu para bar",
    img: "Menu.png",
    url: "https://menureactjssebaanea.netlify.app/",
    github: "https://github.com/sebastiananea/Menu",
  },
  {
    title: "Reviews",
    description: "Practica useState con pequeña SPA de reviews",
    img: "Reviews.png",
    url: "https://reviewssebaanea.netlify.app/",
    github: "https://github.com/sebastiananea/reviews",
  },
  {
    title: "Tours",
    description: "Practica React SPA de turismo",
    img: "Tours.png",
    url: "https://tours-react-app-sebastiananea.netlify.app/",
    github: "https://github.com/sebastiananea/Tours---React-Project",
  },
  {
    title: "Clima API",
    description: "Practica de Fetch API",
    img: "clima.png",
    url: "https://sebastiananea.github.io/FETCH-API-Clima/",
    github: "https://github.com/sebastiananea/FETCH-API-Clima",
  },
];
